'use client';

import * as React from "react";
import { Loader2 } from "lucide-react";

interface AuthLoadingScreenProps {
  readonly isLoggingOut?: boolean;
}

export const AuthLoadingScreen: React.FC<AuthLoadingScreenProps> = ({
  isLoggingOut = false,
}) => {
  const getLoadingMessage = () => {
    if (isLoggingOut) {
      return {
        title: "Signing out...",
        description: "We're securely logging you out.",
      };
    }
    return {
      title: "Validating...",
      description: "Please wait while we verify your credentials.",
    };
  };

  const { title, description } = getLoadingMessage();

  return (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="flex flex-col items-center space-y-6">
      {/* Inline logo + text horizontally */}
      <div className="flex items-center space-x-4">
        {/* Light theme logo */}
        <img
          src="/wilabs-logo.svg"
          alt="WiLine Workforce logo"
          className="h-10 w-auto object-contain block dark:hidden"
        />

        {/* Dark theme logo */}
        <img
          src="/wilabs-logo.svg"
          alt="WiLine Workforce logo"
          className="h-10 w-auto object-contain hidden dark:block"
        />

        {/* Text */}
        <div className="text-left">
          <h2 className="text-lg font-semibold text-foreground">{title}</h2>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>

      {/* Loader below (optional) */}
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  </div>
);
};
